module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNpiYBjqgBFdoLS0tAFI1ROhd0F3d3ciIUVMWMTqiXRcAtAx88mxgBRA0BImKgQzXkuYqBSXOC1hIdYEYIQyoiWG/1gsYUCPeCYqp8oEWgURA63jYOAsIBTJE4CRVogv0qGpJ4FcHxTgS+OEDCc2iLCmcWIMJyUOUCwh1nCSMhosI+FK79SwgCSDRzMaRRY0UmBeI8OwAwABBgBXIS+vsr4QmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/bill-download.png
// module id = 607
// module chunks = 0